'use strict';

let isIpadMax = require('./utilities/clientSideUtil').isIpadMax;
import { Glide, Controls, Swipe, Breakpoints } from './components/carousel';
var glide;

/**
 * Creates carousel bullet items
 * @param {jQuery} $parentEl container element
 */
function createControls($parentEl) {
    const $carouselItems = $($parentEl).find('.glide__slide').not('.glide__slide--clone');
    let $carouselBullets = $($parentEl).find('[data-glide-el="controls[nav]"]');
    $carouselBullets.empty();
    $carouselItems.each(function (index) {
        var $newIndiator = $(`<button class="glide__bullet" data-glide-dir="=${index}" aria-label="Slide ${index + 1}"></button>`);
        $carouselBullets.append($newIndiator);
    });
    $carouselBullets.removeClass('d-none');
}

/**
 * Initialize carousel
 * @param {jQuery} $containerEl the wrapper element
 */
function initializeCarousel($containerEl) {
    const $carousel = $($containerEl);
    const $carouselItems = $($carousel).find('.glide__slide').not('.glide__slide--clone');
    const $controls = $($carousel).find('[data-glide-el="controls"]');
    const totalSlides = $carouselItems.length;
    var peakAfterDesktop = $carousel.find('.layout-type-horizontal').length > 1 ? '320' : '106';
    const defaults = {
        type: 'carousel',
        perView: 1,
        rewind: true,
        gap: 16,
        peek: {
            before: 0,
            after: peakAfterDesktop
        },
        breakpoints: {
            1439: {
                rewind: true,
                gap: 0,
                peek: {
                    before: 0,
                    after: 0
                }
            }
        }
    };

    const handleUpdateEvent = () => {
        if (!glide) { return; }
        const { perView } = glide.settings;
        if (totalSlides <= perView) {
            $controls.addClass('d-none');
            $($carousel).find('.glide__controls').removeClass('d-flex').addClass('d-none');
        } else {
            $controls.removeClass('d-none');
            $($carousel).find('.glide__controls').removeClass('d-none').addClass('d-flex');
            $($carousel).find('.product-card').addClass('active-slider');
        }
        setTimeout(() => { $($carousel).addClass('glide--animated') }, 300);
    }

    if (glide) {
        glide.destroy();
        glide = null;
    }

    glide = new Glide($carousel.get(0), defaults)
        .mount({
            Controls,
            Breakpoints,
            Swipe
        });
    setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
    });

    handleUpdateEvent()
}

$(document).ready(function () {
    $(document).on("click", ".shoppable-products-cta-js", function () {
        let productsCard;
        $(this).addClass('d-none');
        if ($(this).hasClass('view-products-cta')) {
            if (isIpadMax()) {
                productsCard = $(this).siblings('.shoppable-products-carousel-desktop-js');
                productsCard.each(function () {
                    if ($(this).find('.product-card').length > 1) {
                        createControls(this);
                        initializeCarousel(this);
                    }
                });
                productsCard.removeClass('d-lg-none').addClass('d-lg-block');
            } else {
                productsCard = $(this).parents('.mbb-assets-shoppable-image-card').find('.shoppable-products-carousel-mobile-js');
                productsCard.each(function () {
                    if ($(this).find('.product-card').length > 1) {
                        createControls(this);
                        initializeCarousel(this);
                    }
                });
                productsCard.removeClass('d-none');
            }
            $(this).siblings('.hide-products-cta').removeClass('d-none');
        } else {
            if (isIpadMax()) {
                $(this).siblings('.shoppable-products-carousel-desktop-js').removeClass('d-lg-block').addClass('d-lg-none');
            } else {
                $(this).parents('.mbb-assets-shoppable-image-card').find('.shoppable-products-carousel-mobile-js').addClass('d-none');
            }
            $(this).siblings('.view-products-cta').removeClass('d-none');
        }
    });
});